"use strict";

import { campaignConstants } from "./campaign.constant";
import { userConstants } from "./user.constants";
import { authConstants } from "./auth.constants";
import { shopConstants } from "./shop.constants";
import { knowledgeConstants } from "./knowledge.constants";
import { homeConstants } from "./home.constants";

export const LOCATION_FROM = "LOCATION_FROM";

export const routeLocationLocalStorage = {
    HOME: "HOME",
    CAMPAIGN: "CAMPAIGN",
};

export const commonConstants = {
    AJAX_ERROR: "AJAX_ERROR",
    REFRESH_TOKEN_ERROR: "REFRESH_TOKEN_ERROR",
    AJAX_SUCCESS: "AJAX_SUCCESS",
    HIDE_AJAX_SUCCESS: "HIDE_AJAX_SUCCESS",

    HIDE_SUCCESS_SERVER_MESSAGE: "HIDE_SUCCESS_SERVER_MESSAGE",

    SHOW_ERROR_SERVER_MESSAGE: "SHOW_ERROR_SERVER_MESSAGE",

    HIDE_ERROR_SERVER_MESSAGE: "HIDE_ERROR_SERVER_MESSAGE",

    SHOW_ERROR_CUSTOM_SERVER_MESSAGE: "SHOW_ERROR_CUSTOM_SERVER_MESSAGE",
    HIDE_ERROR_CUSTOM_SERVER_MESSAGE: "HIDE_ERROR_CUSTOM_SERVER_MESSAGE",

    SHOW_SUCCESS_SERVER_MESSAGE: "SHOW_SUCCESS_SERVER_MESSAGE",

    TYPE_SUCCESS_MESSAGE: "TYPE_SUCCESS_MESSAGE",
    TYPE_ERROR_MESSAGE: "TYPE_ERROR_MESSAGE",

    ADD_PENDING_ACTIONS: "ADD_PENDING_ACTIONS",
    REMOVE_PENDING_ACTIONS: "REMOVE_PENDING_ACTIONS",

    SHOW_POPUP: "SHOW_POPUP",
    HIDE_POPUP: "HIDE_POPUP",

    IMAGE_UPLOAD_REQUEST: "IMAGE_UPLOAD_REQUEST",
    IMAGE_UPLOAD_COMPLETE: "IMAGE_UPLOAD_COMPLETE",
    IMAGE_UPLOAD_ERROR: "IMAGE_UPLOAD_ERROR",
    IMAGE_UPLOAD_CLEAR: "IMAGE_UPLOAD_ERROR",
};

export const requestTypes = {
    REQUEST_TYPE_POST: "POST",
    REQUEST_TYPE_GET: "GET",
    REQUEST_TYPE_FILE_UPLOAD: "FILE_UPLOAD",
};

export const loadingSelectArray = [
    campaignConstants.CAMPAIGN_GET_LATEST_CAMPAIGN_REQUEST,
    campaignConstants.GET_HOME_BEST_VOUCHER_DEALS_TODAY_REQUEST,
    campaignConstants.GET_HOME_CAROUSEL_CAMPAIGN_REQUEST,
    campaignConstants.GET_HOME_TRENDING_VOUCHER_REQUEST,
    campaignConstants.CAMPAIGN_SPINWIN_TOKEN_VALIDATION_REQUEST,
    campaignConstants.GET_CAMPAIGN_DETAILS_REQUEST,
    campaignConstants.CAMPAIGN_SPINWIN_GET_INITIAL_DATA_REQUEST,
    campaignConstants.JOING_INCENTIVE_DATA_REQUEST,
    campaignConstants.CAMPAIGN_VOUCHER_ADDTO_FAVOURITE_REQUEST,
    campaignConstants.CAMPAIGN_VOUCHER_REMOVEFROM_FAVOURITE_REQUEST,
    campaignConstants.GET_CAMPAIGN_PRIZEDRAW_DETAILS_REQUEST,
    campaignConstants.ADD_PRIZE_DRAW_CAMPAIGN_ENTRY_DATA_REQUEST,
    campaignConstants.GET_LEAGUE_INDIVIDUAL_DETAILS_DATA_REQUEST,
    campaignConstants.GET_LEAGUE_TEAM_DETAILS_DATA_REQUEST,
    campaignConstants.SUBMIT_LEAGUE_TEAM_PARTICIPANT_REQUEST,
    campaignConstants.GET_COMMS_DETAILS_REQUEST,
    campaignConstants.CAMPAIGN_SPINWIN_GET_DATA_REQUEST,
    campaignConstants.CAMPAIGN_GET_WARE_AND_TIRE_SUMMARY_REQUEST,
    campaignConstants.CAMPAIGN_GET_PARTICIPANT_ACTIVE_CAMPAIGNS_REQUEST,
    campaignConstants.CAMPAIGN_PAGE_LIKE_CONTENT_REQUEST,
    campaignConstants.CAMPAIGN_PAGE_LIKE_SUMMARY_REQUEST,
    campaignConstants.CAMPAIGN_GET_PARTICIPANTS_BY_DEALERS_REQUEST,

    campaignConstants.CAMPAIGN_GET_PERFORMANCE_METRICS_BY_DEALERS_DROP_DOWN_REQUEST,
    campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BATTERY_SUMMARY_DROP_DOWN_REQUEST,
    campaignConstants.CAMPAIGN_GET_LEAGUE_NATIONAL_TOP_PERFORMER_SUMMARY_DROP_DOWN_REQUEST,
    campaignConstants.CAMPAIGN_GET_LEAGUE_TABLE_SUMMARY_DROP_DOWN_REQUEST,
    campaignConstants.CAMPAIGN_GET_CASTROL_LEAGUE_TABLE_Q4_SUMMARY_REQUEST,
    campaignConstants.CAMPAIGN_GET_ALPINE_REWARD_SUMMARY_REQUEST,
    campaignConstants.CAMPAIGN_GET_CASTROL_MOTO_GP_LEAGUES_RANK_SUMMARY_REQUEST,
    campaignConstants.CAMPAIGN_GET_AREA_MANAGERS_DEALERS_REQUEST,
    campaignConstants.CAMPAIGN_GOLDEN_TICKET_SCRATCH_CARD_DATA_REQUEST,
    campaignConstants.CAMPAIGN_POST_REWARD_AND_RECOGNITION_NOMINATION_SEND_REQUEST,

    // campaignConstants.CAMPAIGN_GET_PARTICIPANT_INCENTIVE_PERFORMANCE_METRICS_REQUEST,
    // campaignConstants.CAMPAIGN_GET_CASTROL_LEAGUE_TABLE_SUMMARY_REQUEST,
    // campaignConstants.CAMPAIGN_PAGE_LOG_PAGE_VIEW_REQUEST,
    //  campaignConstants.CAMPAIGN_GET_AREA_MANAGERS_DEALERS_REQUEST,
    //campaignConstants.CAMPAIGN_GET_LEAGUE_TABLE_SUMMARY_REQUEST,
    //campaignConstants.CAMPAIGN_GET_PERFORMANCE_METRICS_BY_DEALERS_REQUEST,
    //  campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BATTERY_SUMMARY_REQUEST,
    // campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BRAKE_PADS_SUMMARY_REQUEST,
    // campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_WIPER_BLADE_SUMMARY_REQUEST,
    // campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BRAKE_DISCS_SUMMARY_REQUEST,
    // campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_AREA_TOP_SUMMARY_REQUEST,
    // campaignConstants.CAMPAIGN_GET_LEAGUE_NATIONAL_TOP_PERFORMER_SUMMARY_REQUEST,

    campaignConstants.CAMPAIGN_GET_WEAR_AND_TEAR_TEAM_PERFORMANCE_SUMMARY_REQUEST,

    campaignConstants.GET_GOLD_RUSH_CAMPAIGN_PERFORMANCE_SUMMARY_REQUEST,
    campaignConstants.GET_GOLD_RUSH_CAMPAIGN_PERFORMANCE_SUMMARY_COMPLETE,
    campaignConstants.GET_TLC_CUSTOMER_REQUEST,
    campaignConstants.GET_CASTROL_DEALER_PERFORMANCE_SUMMARY_REQUEST,
    campaignConstants.CAMPAIGN_SERVICE_STAR_GET_SERVICE_STAR_LEAGUE_RANK_SUMMARY_REQUEST,
    campaignConstants.CAMPAIGN_GET_TRADE_PARTS_MANAGER_INCENTIVE_REQUEST,

    userConstants.USER_GET_LATEST_ACHIEVEMENTS_REQUEST,
    userConstants.USER_GET_THINGS_TO_DO_REQUEST,
    userConstants.USER_MEMBERSHIP_REQUEST,
    userConstants.USER_POINTS_TRANSACTIONS_REQUEST,
    userConstants.USER_GOALS_REQUEST,
    userConstants.USER_INCENTIVE_HISTORY_REQUEST,
    userConstants.GET_NEWS_FEED_REQUEST,
    userConstants.GET_PARTICIPANT_NOTIFICATION_REQUEST,
    userConstants.READ_NOTIFICATION_REQUEST,
    userConstants.GET_USER_POINTS_BALANCE_REQUEST,

    // shopConstants.FAVOURITES_REQUEST,
    shopConstants.TOP_PICKS_REQUEST,
    shopConstants.VOUCHER_DETAILS_REQUEST,
    shopConstants.CONFIRM_ORDER_REQUEST,
    shopConstants.ORDER_DETAILS_REQUEST,
    shopConstants.VOUCHER_WALLET_REQUEST,
    shopConstants.BROWSE_PRODUCTS_REQUEST,
    shopConstants.SHOP_TLC_REBAT_POINTS_REQUEST,

    authConstants.AUTH_LOGIN_REQUEST,
    authConstants.FORGOT_PASSWORD_EMAIL_VERIIFICATION_REQUEST,
    authConstants.SEND_OTP_REQUEST,
    authConstants.AUTH_LOGOUT_REQUEST,
    authConstants.PRE_REGISTRATION_ACTIVATE_REQUEST,
    authConstants.PRE_REGISTRATION_REQUEST,
    authConstants.FORGOT_PASSWORD_RESET_PASSWORD_REQUEST,
    //authConstants.AUTH_CHANGE_PASSWORD_REQUEST,
    authConstants.AUTH_SEND_OTP_AFTER_LOGIN_REQUEST,
    authConstants.AUTH_SUBSCRIBE_REQUEST,

    knowledgeConstants.KNOWLEDGE_LATEST_QUIZZES_REQUEST,
    knowledgeConstants.KNOWLEDGE_DASHBOARD_REQUEST,
    knowledgeConstants.KNOWLEDGE_PARTICIPANT_QUIZZES_REQUEST,
    knowledgeConstants.KNOWLEDGE_QUIZZE_DETAILS_REQUEST,
    knowledgeConstants.KNOWLEDGE_ANSWER_QUESTION_REQUEST,
    knowledgeConstants.KNOWLEDGE_ENROL_QUIZZE_REQUEST,
    knowledgeConstants.KNOWLEDGE_QUESTION_RESULT_REQUEST,

    homeConstants.HOME_CAMPAIGN_LIST_REQUEST,
    homeConstants.HOME_GET_PARTICIPANT_LIST_REQUEST,
    homeConstants.HOME_GET_REALTIME_REWARD_CODE_REQUEST,
    homeConstants.HOME_GET_REALTIME_REWARD_REASON_LIST_REQUEST,
    homeConstants.HOME_SMS_REALTIME_REWARD_CODE_REQUEST,
    homeConstants.HOME_GET_REAL_TIME_REWARD_CAMPAIGN_REQUEST,
    homeConstants.GET_DEALER_PARTICIPANT_LIST_REQUEST,
    homeConstants.GET_PARTICIPANT_JOB_ROLES_REQUEST,
    homeConstants.REGISTER_DEALER_PARTICIPANT_REQUEST,
    homeConstants.UPDATE_DEALER_PARTICIPANT_STATUS_REQUEST,
    homeConstants.REMOVE_DEALER_PARTICIPANT_REQUEST,
    homeConstants.SEND_ACTIVATE_ACCOUNT_REQUEST,
    homeConstants.HOME_GET_TEAM_GAME_PLAY_DETAILS_REQUEST,
    homeConstants.HOME_GET_TEAM_SEND_GAME_PLAY_CODE_REQUEST,
    homeConstants.HOME_GET_TEAM_RESET_GAME_PLAY_CODE_REQUEST,
    // homeConstants.HOME_CHATBOT_REPLY_QUESTION_REQUEST,
    // authConstants.AUTH_CHANGE_PASSWORD_REQUEST,
    // authConstants.AUTH_CHANGE_MOBILE_NUMBER_REQUEST,
    authConstants.RE_SEND_OTP_REQUEST,
    commonConstants.IMAGE_UPLOAD_REQUEST,
    shopConstants.REDEEM_VOUCHER_REQUEST,
    shopConstants.RATE_VOUCHER_REQUEST,
];

export const successMessagesList = [
    campaignConstants.JOING_INCENTIVE_DATA_COMPLETE,
    campaignConstants.CAMPAIGN_VOUCHER_ADDTO_FAVOURITE_COMPLETE,
    campaignConstants.CAMPAIGN_VOUCHER_REMOVEFROM_FAVOURITE_COMPLETE,
    // knowledgeConstants.KNOWLEDGE_ENROL_QUIZZE_COMPLETE,
    homeConstants.HOME_SMS_REALTIME_REWARD_CODE_COMPLETE,
    campaignConstants.ADD_PRIZE_DRAW_CAMPAIGN_ENTRY_DATA_COMPLETE,
    campaignConstants.SUBMIT_LEAGUE_TEAM_PARTICIPANT_COMPLETE,
    authConstants.FORGOT_PASSWORD_EMAIL_VERIIFICATION_COMPLETE,
    authConstants.FORGOT_PASSWORD_RESET_PASSWORD_COMPLETE,
    authConstants.PRE_REGISTRATION_ACTIVATE_COMPLETE,
    authConstants.AUTH_CHANGE_PASSWORD_COMPLETE,
    authConstants.AUTH_CHANGE_MOBILE_NUMBER_COMPLETE,
    homeConstants.REGISTER_DEALER_PARTICIPANT_COMPLETE,
    homeConstants.UPDATE_DEALER_PARTICIPANT_STATUS_COMPLETE,
    homeConstants.REMOVE_DEALER_PARTICIPANT_COMPLETE,
    homeConstants.SEND_ACTIVATE_ACCOUNT_COMPLETE,
    authConstants.RE_SEND_OTP_COMPLETE,
    authConstants.AUTH_CHANGE_NOTIFICATION_COMPLETE,
    // commonConstants.IMAGE_UPLOAD_COMPLETE,
    shopConstants.RATE_VOUCHER_COMPLETE,
];

export const errorResponseCodes = {
    504: "Couldn't connect to server, Please try again.",
};

export const responseCodes = {
    SUCCESS_CODE: "00",
    _CODE: "401",
};

export const contextApiActions = {
    UI_RIGHT_SIDE_PANEL_TOGGEL: "UI_RIGHT_SIDE_PANEL_TOGGEL",
    UI_CONFIRMATION_TOGGEL: "UI_CONFIRMATION_TOGGEL",
    SET_SIGNALR_CONNECTTION: "SET_SIGNALR_CONNECTTION",
    SET_REQUESTED_URL: "SET_REQUESTED_URL",
};

export const frontEndSuccessMessages = {
    [campaignConstants.JOING_INCENTIVE_DATA_COMPLETE]:
        "Successfully joined to incentive!",
    [campaignConstants.CAMPAIGN_VOUCHER_ADDTO_FAVOURITE_COMPLETE]:
        "Successfully added to favourites!",
    [campaignConstants.CAMPAIGN_VOUCHER_REMOVEFROM_FAVOURITE_COMPLETE]:
        "Successfully removed from favourites!",

    [knowledgeConstants.KNOWLEDGE_ENROL_QUIZZE_COMPLETE]:
        "Successfully enroled to Quizz!",

    [homeConstants.HOME_SMS_REALTIME_REWARD_CODE_COMPLETE]:
        "Successfully sent SMS to recipient!",

    [campaignConstants.ADD_PRIZE_DRAW_CAMPAIGN_ENTRY_DATA_COMPLETE]:
        "Successfully added to prize draw entry!",
    [campaignConstants.SUBMIT_LEAGUE_TEAM_PARTICIPANT_COMPLETE]:
        "Team updated successfully!",
    [authConstants.FORGOT_PASSWORD_EMAIL_VERIIFICATION_COMPLETE]:
        "Email sent successfully!",
    [authConstants.FORGOT_PASSWORD_RESET_PASSWORD_COMPLETE]:
        "Your password changed successfully!",

    [authConstants.PRE_REGISTRATION_ACTIVATE_COMPLETE]:
        "Your acount acitivated successfully!",

    [authConstants.AUTH_CHANGE_PASSWORD_COMPLETE]:
        "Your password change successfully!",

    [authConstants.AUTH_CHANGE_MOBILE_NUMBER_COMPLETE]:
        "Your mobile number change successfully!",

    [homeConstants.REGISTER_DEALER_PARTICIPANT_COMPLETE]:
        "Team member added successfully!",

    [homeConstants.UPDATE_DEALER_PARTICIPANT_STATUS_COMPLETE]:
        "Participant status updated successfully!",

    [homeConstants.REMOVE_DEALER_PARTICIPANT_COMPLETE]:
        "Participant removed successfully!",

    [homeConstants.SEND_ACTIVATE_ACCOUNT_COMPLETE]:
        "Participant invite sent successfully!",

    [authConstants.RE_SEND_OTP_COMPLETE]: "Otp  sent successfully!",

    [authConstants.AUTH_CHANGE_NOTIFICATION_COMPLETE]:
        "Notification setting update!",

    // [commonConstants.IMAGE_UPLOAD_COMPLETE]:
    //     "Profile image upload successfully!",

    [shopConstants.RATE_VOUCHER_COMPLETE]: "Voucher rated successfully!",
};

export const signalrTopics = {
    GET_VOUCHER_UPDATE: "SendVoucherUpdate",
};
